import { forwardRef } from "react";
function SvgRawArticleIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={32}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={26.997}
        height={30.998}
        x={0.5}
        y={0.501}
        fill="#fff"
        stroke="#DDD"
        rx={1.5}
      />
      <path fill="#E7F1FF" d="M2 3a1 1 0 0 1 1-1h21.998a1 1 0 0 1 1 1v9H2V3Z" />
      <path
        fill="#959595"
        d="M4 8.666h16.666a2 2 0 0 1 2 2v6H4v-8ZM4 19.334c0-.368.298-.667.667-.667h14.665a.667.667 0 1 1 0 1.333H4.667A.667.667 0 0 1 4 19.334Z"
      />
      <path
        fill="#333"
        d="M4 5.333c0-.368.298-.666.667-.666h15.332a.667.667 0 1 1 0 1.333H4.667A.667.667 0 0 1 4 5.333Z"
      />
      <path
        fill="#959595"
        d="M4 22.666c0-.369.298-.667.667-.667h14.665a.667.667 0 0 1 0 1.333H4.667A.667.667 0 0 1 4 22.666ZM4 26.001c0-.368.298-.667.667-.667h15.999a.667.667 0 0 1 0 1.334h-16A.667.667 0 0 1 4 26Z"
      />
      <circle
        cx={25.33}
        cy={20.666}
        r={6.666}
        fill="#fff"
        stroke="#DDD"
        strokeWidth={2}
      />
      <path
        fill="#106FF3"
        fillRule="evenodd"
        d="M25.33 27.114a6.447 6.447 0 1 0 0-12.894 6.447 6.447 0 0 0 0 12.894Zm2.42-8.685a.5.5 0 1 0-.874-.486l-2.105 3.79-1.025-1.367a.5.5 0 0 0-.8.6l1.488 1.983a.5.5 0 0 0 .837-.057l2.48-4.463Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawArticleIcon);
export default ForwardRef;
